import React, { FC, ReactNode } from 'react';
import './styles/ApplicationCard.css';

interface ApplicationCardProps {
  icon: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
  onClickText: string;
  betaFlag?: boolean;
}
/**
 * This is a card for an application
 * @param param
 * @param param.icon - icon for the card
 * @param param.title - title for the card
 * @param param.description - description for the card
 * @param param.onClick - function to call when the card is clicked
 * @param param.onClickText - text to display on the button
 * @param param.betaFlag - boolean to trigger the beta flag on or off
 * @returns - a card for an application
 */
export const ApplicationCard: FC<ApplicationCardProps> = ({
  icon,
  title,
  description,
  onClick,
  onClickText,
  betaFlag = false
}) => {

  return (
    <div className='ml_application_landing_page_custom_app_card'>
      {icon}
      <label className='ml_application_landing_page_custom_app_card_label'>
        {title}
        {betaFlag && <span className='ml_application_beta_flag'>BETA</span>}
      </label>
      <p className='ml_application_landing_page_custom_app_card_description'>{description}</p>
      <button onClick={onClick} className='ml_application_landing_page_custom_card_button' >{onClickText}</button>
    </div>
  );
};
